export default __webpack_public_path__ + "static/media/logo_solid_512.9b8d2d03.png";